export default "__VITE_ASSET__ByfUAZNA__"